import React from 'react';
import RecentOrderBar from './RecentOrderBar';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getOrderStatus, getStatusColor } from '../../../../lib/utils/utils';

function RecentOrdersCollection() {
    const dashboard = useSelector((state) => state.dashboard.dashboard.dashboard);

    return (
        <div className="border rounded-lg border-[#EAEAEA] mt-3 mx-5 pb-2">
            <div className="flex items-center justify-between p-4">
                <h1 className="text-[#121212] text-base font-semibold">Recent Orders</h1>

                <Link to='/order-management' className="text-[#1055EB] font-semibold text-[12px] leading-6" href="/">View all</Link>
            </div>

            <div className="flex bg-[#F5F5F5] font-semibold text-[14px] leading-6 text-[#666666]">
                <h2 className="w-[30%] p-[8px_10px_8px_16px] uppercase">Products</h2>
                <h2 className="w-[14%] px-[10px] py-[8px]">Order Id</h2>
                <h2 className="w-[14%] px-[10px] py-[8px]">Order Value</h2>
                <h2 className="w-[14%] px-[10px] py-[8px]">Unit Price</h2>
                <h2 className="w-[14%] px-[10px] py-[8px]">Total Price</h2>
                <h2 className="w-[14%] px-[10px] py-[8px]">Status</h2>
            </div>

            {
                Object.keys(dashboard).length > 0 && 
                (
                    dashboard.latestOrder.length > 0 && 
                    dashboard.latestOrder.map(order => {
                        const statusColors = getStatusColor(order.orderStatus);
                        const status = getOrderStatus(order.orderStatus);

                        return (
                            <RecentOrderBar 
                                orderStatus={status} 
                                key={order.orderId} 
                                order={order} 
                                statusColors={statusColors} 
                            />
                        )
                    })
                )
            }
        </div>
    )
}

export default RecentOrdersCollection;
